import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  0% { transform: rotate( 0deg ); }
  100% { transform: rotate( 359deg ); }
`

const tremor = keyframes`
  0% {
    transform: rotateZ(0deg);
  }
  25% {
    transform: rotateZ(5deg);
  }
  50% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(-5deg);
  }
`

export const Svg = styled.svg`
  height: 259px;
  width: 259px;

  g {
    transform: translateY(10px);
  }

  g.backend-hexagon_svg__backend {
    transform: translate(25px, 60px);
  }
  g.java_svg__java {
    transform: translate(15px, 30px);
  }

  g.cicd-hexagon_svg__cicd {
    transform: translate(25px, 50px);
  }

  g.iaas-hexagon_svg__iaas {
    transform: translate(25px, 50px);
  }

  g.iaas-hexagon_svg__iaas-text {
    transform: translateY(0);
  }

  .angular-hexagon_svg__angular-shield {
    stroke: ${({ theme }) => theme.colors.blueGray};
    transition: 0.2s ease-in-out all;
  }

  .feedback-software-development_svg__software-dev {
    transform: translate(30px, 60px);
  }

  .logistic-hexagon_svg__truck,
  .fintech-hexagon_svg__increase,
  .medtech-hexagon_svg__heart,
  .medtech-hexagon_svg__other,
  .iot-hexagon_svg__figure,
  .frontend-hexagon_svg__frontend,
  .java_svg__java,
  .react-hexagon_svg__react,
  .front-vue-hexagon_svg__vue,
  .android-hexagon_svg__android,
  .python-hexagon_svg__python,
  .spring-hexagon_svg__spring,
  .backend-hexagon_svg__backend,
  .ios-hexagon_svg__ios,
  .ios-hexagon_svg__ios,
  .angular-hexagon_svg__angular,
  .node-js-hexagon_svg__nodejs {
    fill: ${({ theme }) => theme.colors.blueGray};
    transition: 0.2s ease-in-out all;
  }
  .net-hexagon_svg__net {
    fill: #ffb366;
    transition: 0.2s ease-in-out all;
  }

  g + path {
    fill: ${({ theme }) => theme.colors.blueGray};
    transition: 0.2s ease-in-out all;
  }

  .devops-hexagon_svg__asd {
    transform: translateY(0);
  }

  &:hover {
    .filled {
      stroke-width: 8;
    }
    g + path,
    .ios-hexagon_svg__ios,
    .logistic-hexagon_svg__truck,
    .fintech-hexagon_svg__increase,
    .medtech-hexagon_svg__heart,
    .iot-hexagon_svg__figure,
    .frontend-hexagon_svg__frontend,
    .react-hexagon_svg__react,
    .front-vue-hexagon_svg__vue,
    .mobile-development-hexagon_svg__mobile-development,
    .net-hexagon_svg__net,
    .android-hexagon_svg__android,
    .python-hexagon_svg__python,
    .spring-hexagon_svg__spring,
    .php-hexagon_svg__php,
    .java_svg__java,
    .backend-hexagon_svg__backend,
    .angular-hexagon_svg__angular,
    .node-js-hexagon_svg__nodejs,
    .flutterHexagon_svg__flutter,
    .lock-hexagon_svg__check-mark {
      fill: ${({ theme }) => theme.colors.primary};
      defs stop {
        stop-color: ${({ theme }) => theme.colors.primary};
        transition: 0.2s ease-in-out all;
      }
    }
    .php-hexagon_svg__php-border {
      fill-opacity: 0;
      stroke: ${({ theme }) => theme.colors.primary};
      stroke-width: 2;
    }
    .tractor_svg__tractor {
      fill-opacity: 1;
    }
    .php-hexagon_svg__php {
      opacity: 1;
    }
    .scale-team_svg__team {
      stop-color: ${({ theme }) => theme.colors.primary};
      transition: 0.2s ease-in-out all;
    }
    .angular-hexagon_svg__angular-shield {
      stroke: ${({ theme }) => theme.colors.primary};
      transition: 0.2s ease-in-out all;
    }
    g defs stop {
      stop-color: ${({ theme }) => theme.colors.primary};
      transition: 0.2s ease-in-out all;
    }
    .scale-team_svg__rotate {
      animation-duration: 3s;
      animation-iteration-count: 1;
      animation-name: ${rotate};
      transform-box: fill-box;
      transform-origin: 69% 55%;
    }
    .adtech-lets-talk-hexagon_svg__wheel,
    .devops-hexagon_svg__wheel,
    .cicd-hexagon_svg__rotate,
    .orchestration-hexagon_svg__rotate,
    .approach-hexagon_svg__permanent,
    .qa-hexagon_svg__wheel {
      animation-duration: 3s;
      animation-iteration-count: 1;
      animation-name: ${rotate};
      transform-box: fill-box;
      transform-origin: 50% 50%;
    }
    .social-net-hexagon_svg__letter {
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-name: ${tremor};
      transform-box: fill-box;
      transform-origin: 50% 45%;
    }
    .flutterHexagon_svg__flutter-wrapper {
      opacity: 1;
    }
    .handshake-mobile_svg__partnership_handshake,
    .handshake_svg__partnership_handshake {
      & > path {
        transition: 1s;
        fill: ${({ theme }) => theme.newColors.accent};
      }
    }
  }

  g:hover {
    defs stop {
      stop-color: ${({ theme }) => theme.colors.primary};
      transition: 0.2s ease-in-out all;
    }
  }
`

export const EmptyPath = styled.path`
  fill: transparent;
  fill-opacity: 0.01;
  stroke: ${({ theme }) => theme.colors.primary};
  stroke-width: 4;

  &:hover {
    stroke-width: 6;
  }
`

export const FilledPath = styled.path`
  fill: ${({ theme }) => theme.colors.secondary};
  stroke: ${({ theme }) => theme.colors.secondary};
  stroke-width: 1;

  &:hover {
    stroke-width: 8;
    ~ g defs stop {
      stop-color: ${({ theme }) => theme.colors.primary};
      transition: 0.2s ease-in-out all;
    }
  }
`
